import React from 'react';

const ConversationsList = ({ conversations, selectedId, onSelect, currentUser }) => {
  // Format conversation timestamp to relative time
  const formatRelativeTime = (timestamp) => {
    const now = new Date();
    const then = new Date(timestamp);
    const diffMs = now - then;
    
    // Convert to seconds, minutes, hours, days
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHrs = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHrs / 24);
    
    if (diffDays > 0) {
      return diffDays === 1 ? 'Yesterday' : `${diffDays} days ago`;
    } else if (diffHrs > 0) {
      return `${diffHrs}h ago`;
    } else if (diffMin > 0) {
      return `${diffMin}m ago`;
    } else {
      return 'Just now';
    }
  };
  
  // Truncate message content for preview
  const truncateContent = (content, maxLength = 30) => {
    if (content.length <= maxLength) return content;
    return content.substring(0, maxLength) + '...';
  };
  
  return (
    <ul className="divide-y divide-gray-100">
      {conversations.map(conversation => (
        <li 
          key={conversation.user_id}
          onClick={() => onSelect(conversation)}
          className={`px-3 py-2 cursor-pointer hover:bg-gray-50 ${
            selectedId === conversation.user_id 
              ? 'bg-blue-50' 
              : conversation.unread_count > 0 
                ? 'bg-yellow-50' 
                : ''
          }`}
        >
          <div className="flex items-center justify-between mb-1">
            <div className="flex items-center">
              <div className={`h-2 w-2 rounded-full mr-2 ${
                conversation.last_active && new Date(conversation.last_active) > new Date(Date.now() - 5 * 60 * 1000) 
                ? 'bg-green-500' : 'bg-gray-300'
              }`}></div>
              <span className={`text-sm text-gray-900 ${
                conversation.unread_count > 0 ? 'font-bold' : 'font-medium'
              }`}>{conversation.name}</span>
            </div>
            <span className="text-xs text-gray-500">
              {formatRelativeTime(conversation.last_message.created_at)}
            </span>
          </div>
          
          <div className="flex justify-between items-center">
            <p className="text-xs text-gray-500 w-full truncate">
              {conversation.last_message.is_from_me ? 'You: ' : ''}
              {truncateContent(conversation.last_message.content)}
            </p>
            
            {conversation.unread_count > 0 && conversation.user_id !== currentUser?.id && (
              <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full ml-2">
                {conversation.unread_count}
              </span>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ConversationsList;